import _ from 'lodash'
import React, { useEffect, useState, useCallback, useRef } from 'react'

import MessageItem from './MessageItem'
import NotificationItem from './NotificationItem'
import { getUserId } from '../../helpers/storage/user'
import { formatMessageDate } from '../../helpers/date/date'
import { getMessageDateKey } from '../../helpers/date/messages'

import './style_new.scss'

const MessageView = ({ messages, hasNext, loading, handleNextMessages }) => {
  const observer = useRef()
  const [dates, setDates] = useState([])
  const [payload, setPayload] = useState([])
  const [firstUnreadMessage, setFirstUnreadMessage] = useState(null)

  useEffect(() => {
    const data = _.groupBy(messages, (item) =>
      getMessageDateKey(item.created_at)
    )
    setPayload(data)
    setDates(Object.keys(data))
    if (messages) {
      setFirstUnreadMessage(
        messages.find(
          (message) =>
            !message.is_read &&
            message.user_id.toString() !== getUserId().toString()
        )
      )
    }
  }, [messages])

  const lastElementRef = useCallback(
    (node) => {
      if (loading) return
      if (observer.current) {
        observer.current.disconnect()
      }

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNext && !loading) {
          handleNextMessages()
        }
      })
      if (node) {
        observer.current.observe(node)
      }
    },
    [loading]
  )

  const isFirstMessage = (message) => {
    return messages?.findIndex((item) => item.id === message.id) === 0
  }

  return (
    <>
      {dates.length > 0 &&
        dates.map((date) => {
          const messages = payload[date]
          return messages.map((message, index) => {
            return (
              <span key={`message-item-${index}`}>
                {index === 0 && (
                  <NotificationItem message={formatMessageDate(date)} />
                )}
                {firstUnreadMessage?.id === message?.id && (
                  <div className="messagedate noborder newmsg">
                    <h5>New messages</h5>
                  </div>
                )}
                {isFirstMessage(message) ? (
                  <span ref={lastElementRef}>
                    {' '}
                    <MessageItem message={message} />{' '}
                  </span>
                ) : (
                  <MessageItem message={message} />
                )}
              </span>
            )
          })
        })}
    </>
  )
}

export default MessageView;
